import { ApiConfig } from "./ConstantService";

export async function ValidateCampaign(token, campaign_id) {
  let url_path = "/validate_campaign";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ campaign_id: campaign_id }),
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export async function OnboardCampaign(token, req) {
  let url_path = "/onboard_campaign";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export async function GetOnboardedCampaign(token) {
  let url_path = "/get_onboard_campaigns";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export async function GetCampaignQAResults(token) {
  let url_path = "/get_campaign_qa_results";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export async function GetUsers(token, is_admin) {
  let url_path = is_admin ? "/admin_users" : "/users";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}

export async function SetUsers(token, users, is_admin) {
  let url_path = is_admin ? "/admin_users" : "/users";
  const resp = await fetch(ApiConfig.endpoint + url_path, {
    method: "PUT",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(users),
  });
  let data = await resp.json();
  if (!resp.ok) throw new Error(data.message);
  return data;
}
